import { normalizeFogSettings } from './fogSceneUtils.js';

/**
 * Prepare environment payload for Redux / publish.
 * Drops ephemeral blob: HDRI URLs and normalizes fog + color_config.
 */
export function sanitizeEnvironmentForPersistence(payload = {}) {
  if (!payload || typeof payload !== 'object') return null;

  const fog = normalizeFogSettings(payload);
  const skyboxName = String(payload.skybox?.name || 'Color');
  let hdriFile = payload.hdriFile || payload.skybox?.url || '';

  // blob: URLs are session-only and break after reload.
  if (typeof hdriFile === 'string' && hdriFile.startsWith('blob:')) {
    hdriFile = '';
  }

  const colorConfig = payload.color_config || {};
  const colorType = colorConfig.color_type || payload.colorType || 'Single';

  return {
    ...payload,
    skybox: {
      name: skyboxName,
      url:
        skyboxName.toLowerCase() === 'hdri' && hdriFile
          ? hdriFile
          : payload.skybox?.url && !String(payload.skybox.url).startsWith('blob:')
            ? payload.skybox.url
            : null,
    },
    hdriFile: skyboxName.toLowerCase() === 'hdri' ? hdriFile || '' : '',
    hdriFileName:
      skyboxName.toLowerCase() === 'hdri'
        ? payload.hdriFileName || ''
        : '',
    hdriRotation: String(payload.hdriRotation ?? 0),
    hdriVisible:
      payload.hdriVisible !== undefined ? !!payload.hdriVisible : skyboxName.toLowerCase() === 'hdri',
    hdriLightIntensity: Number(payload.hdriLightIntensity ?? 1),
    ...fog,
    color_config: {
      color_type: colorType,
      color:
        colorType === 'Single'
          ? colorConfig.color || payload.singleColor || '#2D2E32'
          : colorConfig.color || '',
      top_color:
        colorType === 'Gradient'
          ? colorConfig.top_color || payload.gradientTopColor || '#6C6C6C'
          : colorConfig.top_color || '',
      bottom_color:
        colorType === 'Gradient'
          ? colorConfig.bottom_color ||
            payload.gradientBottomColor ||
            '#000000'
          : colorConfig.bottom_color || '',
    },
  };
}
